export default __webpack_public_path__ + "static/media/no_data.3771390f.webp";